var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.398 13.16c3.015 0 5.422 2.617 5.532 5.84l.004.23v1.258c0 .535-.407.976-.929 1.033l-.113.006H4.042c-.537 0-.98-.405-1.036-.926L3 20.488V19.23c0-3.25 2.337-5.942 5.321-6.065l.215-.005h7.862zm0 1.8H8.536c-1.971 0-3.632 1.768-3.731 4.055l-.005.215-.001.496h15.335v-.496c0-2.317-1.602-4.155-3.552-4.265l-.184-.005zM12.468 2c2.696 0 4.879 2.195 4.879 4.897 0 2.703-2.183 4.897-4.88 4.897S7.587 9.6 7.587 6.897C7.588 4.195 9.77 2 12.468 2zm0 1.8c-1.7 0-3.08 1.386-3.08 3.097 0 1.712 1.38 3.097 3.08 3.097 1.699 0 3.079-1.385 3.079-3.097 0-1.711-1.38-3.097-3.08-3.097z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarAccount);
export default __webpack_public_path__ + "static/media/navbar-account.6d35c5138e3b8b615d8019c97b61fd1b.svg";
export { ForwardRef as ReactComponent };